export default "__VITE_ASSET__9d3dd48c__"